import axios from 'axios';

console.log('API URL:', process.env.REACT_APP_API_URL);

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

// [1] 요청 인터셉터: 기존 유지 (매 요청마다 토큰 삽입)
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// [2] 응답 인터셉터 추가: 서버의 응답 에러를 감시
instance.interceptors.response.use(
    (response) => {
        // 성공적인 응답(200번대)은 그대로 통과
        return response;
    },
    (error) => {
        // 에러 응답이 온 경우
        if (error.response) {
            const status = error.response.status;
            const config = error.config;

            const isLoginRequest = config.url.includes('/api/user/login');

            // 401: 인증 실패(토큰 만료 등)
            // 403: 권한 없음(세션 종료 등)
            if ((status === 401 || status === 403) && !isLoginRequest) {
                // 로그인 요청이 아닌데 401/403이 뜬 경우에만 세션 만료 처리
                console.warn("세션이 만료되어 로그아웃 처리합니다.");
                localStorage.clear();
                alert('세션이 만료되었습니다. 다시 로그인해 주세요.');
                window.location.href = '/login'; 
            }
        }
        return Promise.reject(error);
    }
);

export default instance;